import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { Field } from 'formik';
import { TextField } from 'components/FormFields';
import { useStyles } from '../ReservationRulesetCreate.styled';
import i18n from 'i18n-js';

const DetailsInputs = () => {
  const classes = useStyles();
  return (
    <Grid item xs={12} className={classes.paperHeader}>
      {/* TODO Provide ruleset details description
      <Typography variant="body1" align="left" className={classes.ruleDescription}>
        {i18n.t('reservation_rulesets.description')}
      </Typography>
      */}
      <Typography variant="h6" align="left" className={classes.ruleDetails}>
        {i18n.t('reservation_rulesets.ruleset_details')}
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <Field
            data-cy="ruleset-name-input"
            margin="none"
            label={i18n.t('reservation_rulesets.ruleset_name')}
            name="name"
            component={TextField}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Field
            margin="none"
            label={i18n.t('reservation_rulesets.ruleset_description')}
            name="description"
            component={TextField}
            required={false}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <Field
            margin="none"
            label={i18n.t('reservation_rulesets.view_order')}
            name="view_order"
            component={TextField}
            required={false}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export { DetailsInputs };
